import * as R from "ramda";
import { PreferredLocale } from "../utils/locales";

export function loginUIDataToLoginFormBody(data: {
  identifier: string;
  password: string;
}): { identifier: string; secret: string } {
  return {
    identifier: data.identifier,
    secret: data.password,
  };
}

export const enum ClientFeature {
  admin = "admin",
  author = "author",
  dashboard = "dashboard",
  learner = "learner",
  manager = "manager",
  resetCourse = "resetCourse",
}

export function parseLocale(raw: string): PreferredLocale | null {
  return PreferredLocale[raw] || null;
}

export interface IAccessData {
  accessDashboard: boolean;
  canAccessDashboard: boolean;
  canResetCourse: boolean;
  isAdmin: boolean;
  isAuthor: boolean;
  isLearner: boolean;
  isManager: boolean;
}

export function parseClientFeatures(raw: string[]): IAccessData {
  const rawFeatures: Set<string> = new Set(raw);
  return {
    accessDashboard: rawFeatures.has(ClientFeature.dashboard),
    canAccessDashboard: rawFeatures.has(ClientFeature.dashboard) || rawFeatures.has(ClientFeature.admin),
    canResetCourse: rawFeatures.has(ClientFeature.resetCourse),
    isAdmin: rawFeatures.has(ClientFeature.admin),
    isAuthor: rawFeatures.has(ClientFeature.author),
    isLearner: rawFeatures.has(ClientFeature.learner),
    isManager: rawFeatures.has(ClientFeature.manager),
  };
}

export interface ILoginUIData extends IAccessData {
  accountId: string;
  displayName: string;
  emailAddresses: string[];
  ownerOrganizationId: string;
  preferredLocale: PreferredLocale | null;
  primaryEmailAddress: string | null;
  isOrgAdmin: boolean;
}

export function loginPostSuccessResponseToLoginUIData(data: any, extra?: any): ILoginUIData {
  const rawClientFeatures: string[] = R.pathOr([], ["account", "oldClientFeatures"], data);

  return {
    accountId: R.pathOr(null, ["accountId"], data),
    displayName: R.pathOr(null, ["account", "displayName"], data),
    emailAddresses: R.pathOr([], ["account", "emailAddresses", "elems"], data),
    isOrgAdmin: R.pathOr(false, ["isOrgAdmin"], data),
    ownerOrganizationId: R.pathOr(null, ["account", "owner"], data),
    preferredLocale: parseLocale(R.pathOr(null, ["account", "preferredLocale"], data)),
    primaryEmailAddress: R.pathOr(null, ["account", "primaryEmailAddress"], data),
    ...parseClientFeatures(rawClientFeatures),
  };
}

export function loginPostErrorResponseToLoginUIData(data: any, extra?: any): { message: string } {
  if (extra === undefined || extra.response === undefined || extra.response.status !== 401) {
    return { message: "Authentication failed." };
  } else {
    return { message: "Invalid credentials." };
  }
}
